class ColorSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handle = this.getAttribute("product-handle");
    this.setAttribute("data-cs-product-handle", this.handle || "");
    this.setAttribute("data-cs-fetch-status", "loading");

    fetch(`${location.origin}/products/${this.handle}?view=color-swatches`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        this.innerHTML = html;
        this.setAttribute("data-cs-fetch-status", "ok");
      })
      .catch(() => {
        this.setAttribute("data-cs-fetch-status", "error");
      });
  }
}

customElements.define("color-swatches", ColorSwatches);
